import { wrapTextNodes } from './_wrapTextNodes';

export function gallery() {
  // DOM要素を先に取得してキャッシュ
  const gridContainer = document.querySelector('.grid-gallery');
  const body = document.body;
  const els = document.querySelectorAll('.letter-animation');

  // json_posts や必要な配列が正しく存在しなければ処理しない
  if (!gridContainer || typeof json_posts === 'undefined' || !Array.isArray(json_posts.posts)) {
    return;
  }

  // ポスト配列の参照をキャッシュ
  const posts = json_posts.posts;
  // ポスト数のキャッシュ
  const postCount = posts.length;

  // ポストが1個以下かどうかを判定
  let ispostsOnlyOne = postCount <= 1;

  // JSONのポスト順番をシャッフル
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  // posts全体の並び替え
  shuffle(posts);

  // 各ポスト内の画像順番もシャッフル
  posts.forEach(post => {
    shuffle(post.images);
  });

  // Intl.Segmenter は高コストなので一度だけインスタンス化し、再利用
  const jaSegmenter = new Intl.Segmenter('ja', { granularity: 'grapheme' });

  // 日本語の文字を正しく分割する関数
  function segmentText(text) {
    // segmenterで分割→文字配列にし、スペースは除外
    return [...jaSegmenter.segment(text)]
      .map(segment => segment.segment)
      .filter(char => char !== ' ');
  }

  // 各postごとにインデックスと分割済みタイトルを管理
  let postIndices = posts.map(post => ({
    charIndex: 0,
    imageIndex: 0,
    titleArray: segmentText(post.title)
  }));

  let postIndex = 0;        // 現在処理中のpostのインデックス
  let showBlank = false;    // ブランクを表示するフラグ

  // 次の5枚を段階的にプリロードする関数
  function preloadNextImages(callback) {
    let loadedCount = 0;

    for (let i = 0; i < 5; i++) {
      const nextPostIndex = (postIndex + i) % postCount;
      const nextPost = posts[nextPostIndex];
      const nextImageIndex = postIndices[nextPostIndex].imageIndex;
      const nextPostImages = nextPost.images;
      if (nextPostImages[nextImageIndex]) {
        const img = new Image();
        img.src = nextPostImages[nextImageIndex].image;
        img.onload = () => {
          loadedCount++;
          // 5枚すべてロードが完了すればコールバックを呼び出す
          if (loadedCount === 5 && callback) {
            callback();
          }
        };
      }
    }
  }

  function addImageToGrid() {
    if (body.classList.contains('is-pause') || body.classList.contains('is-modal-active')) {
      return;
    }

    if (showBlank && !ispostsOnlyOne) {
      // ブランクを表示
      const blankItem = document.createElement('div');
      blankItem.classList.add('grid-item');
      gridContainer.appendChild(blankItem);

      showBlank = false; 
      postIndex = (postIndex + 1) % postCount; // 次のポストへ

      // スクロールして新しい要素が見えるようにする
      blankItem.scrollIntoView({ behavior: 'smooth' });
    } else {
      const currentPost = posts[postIndex];
      const currentPostIndices = postIndices[postIndex];
      const titleArray = currentPostIndices.titleArray;

      const charIndex = currentPostIndices.charIndex;
      const imageIndex = currentPostIndices.imageIndex;
      const currentTitleChar = titleArray[charIndex];

      // 要素の生成
      const gridItem = document.createElement('div');
      gridItem.classList.add('grid-item');

      const imgElement = document.createElement('img');
      imgElement.src = currentPost.images[imageIndex].image;
      gridItem.appendChild(imgElement);

      if (!ispostsOnlyOne) {
        const titleCharElement = document.createElement('div');
        titleCharElement.classList.add('title-char');
        titleCharElement.innerText = currentTitleChar;
        gridItem.appendChild(titleCharElement);
      }

      gridContainer.appendChild(gridItem);

      // スクロールして新しい要素が見えるようにする
      gridItem.scrollIntoView({ behavior: 'smooth' });

      // 次の文字インデックスを進める
      currentPostIndices.charIndex++;

      if (ispostsOnlyOne) {
        // 画像インデックスを進める
        currentPostIndices.imageIndex++;
        if (currentPostIndices.imageIndex >= currentPost.images.length) {
          currentPostIndices.imageIndex = 0; // ループ
        }
      } else {
        if (currentPostIndices.charIndex >= titleArray.length) {
          // タイトル文字を全て表示し終えたら次はブランクを表示
          showBlank = true;
          currentPostIndices.charIndex = 0; // 次のポストのためにリセット
        } else {
          // 画像インデックスを進める
          currentPostIndices.imageIndex++;
          if (currentPostIndices.imageIndex >= currentPost.images.length) {
            currentPostIndices.imageIndex = 0; // ループ
          }
        }
      }

      // 次の画像をプリロード
      preloadNextImages();
    }
  }

  // 文字アニメーション処理
  let anim = '';
  if (els.length) {
    els.forEach(el => {
      wrapTextNodes(el);
      el.classList.add('is-init');
      const letters = Array.from(el.querySelectorAll('.letter'));

      // 半角スペースを&nbsp;に置き換え
      letters.forEach(letter => {
        letter.innerHTML = letter.innerHTML.replace(/ /g, '&nbsp;');
      });

      let index = 0;
      anim = () => {
        if (!body.classList.contains('is-pause') || !body.classList.contains('is-modal-active')) {
          const length = letters.length;
          if (length > 1) {
            const current = el.querySelector('span.current');
            if (current) current.classList.remove('current');

            // スペースをスキップするためのループ
            let letter = letters[index];
            while (letter.textContent.trim() === '') {
              index++;
              if (index >= length) index = 0;
              letter = letters[index];
            }

            // 次の文字に 'current' クラスを追加
            letter.classList.add('current');

            // インデックスを進める
            index++;
            // 最後の文字に達したらリセット
            if (index >= length) {
              index = 0;
            }
          } else {
            // 1文字のみの場合の処理
            const singleLetter = el.querySelector('span');
            if (singleLetter) {
              if (singleLetter.classList.contains('current')) {
                singleLetter.classList.remove('current');
              } else {
                singleLetter.classList.add('current');
              }
            }
          }
        }
      };
    });
  }

  // 初期化時に最初の5枚をプリロードし、完了後にaddImageToGridを開始
  preloadNextImages(() => {
    setInterval(() => {
      addImageToGrid();
      anim && anim();
    }, 1000);
  });
}